const generateRandomDigits = (digits: number) => {
  // Generates a random number with the specified number of digits
  return Math.floor(
    Math.pow(10, digits - 1) + Math.random() * (Math.pow(10, digits) - Math.pow(10, digits - 1)),
  )
}

export const generateNodeId = (nodeType: string): string => {
  switch (nodeType.toUpperCase()) {
    case 'LN_R':
      return 'B0900ZZZ' + generateRandomDigits(6)

    case 'LN_SCD':
      return 'B0300ZZZ' + generateRandomDigits(6)

    case 'LN_GTWY':
      return 'B0400ZZZ' + generateRandomDigits(6)

    case 'DN_TRP':
      return 'A0100ZZZ' + generateRandomDigits(6)

    case 'DN_Y':
      return 'A0200ZZZ' + generateRandomDigits(6)

    case 'NN_SCD':
      return 'C0303BZZ' + generateRandomDigits(6)

    case 'SCD':

    // eslint-disable-next-line no-fallthrough
    case 'TRP':

    // eslint-disable-next-line no-fallthrough
    case 'RPT':

    // eslint-disable-next-line no-fallthrough
    case 'Y':

    // eslint-disable-next-line no-fallthrough
    case 'GTWY':
      return 'DEADBEEF' + generateRandomDigits(8)

    default:
      throw new Error(`Node ID generation not implemented for node type: ${nodeType}`)
  }
}
